const MarketCategories = {
	financial: "Financial",
	health: "Health & Life Sciences",
	hr: "Human Resources",
	other: "Other",
};
export default MarketCategories;
